"use client";

import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { validation, validationText } from "../../utils/constants.js";
import { useDispatch, useSelector } from "react-redux";
import { errorToast, formatDate, formatTime, success } from "../../utils/helpers.js";
import ThemeInput from "../ThemeComponent/ThemeInput";
import ThemeSelect from "../ThemeComponent/ThemeSelect";
import ThemeTextArea from "../ThemeComponent/ThemeTextArea";
import { SimpleBasic } from "../ThemeComponent/ThemeText";
import {
  useAddappointmentMutation,
  useUpdateappointmentMutation,
} from "../../Redux/services/ClientAPis/appointmentApi";
import ThemeSpinner from "../ThemeComponent/ThemeSpinner";
import { useGetpatientsQuery } from "../../Redux/services/ClientAPis/patientApi";
import { useGetStaffsQuery } from "../../Redux/services/ClientAPis/staffApi";

const CreateAppointment = ({ setIsOpen, modalData, refetch }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1000);
  const [option, setOption] = useState([]);
  const [staffOption, setStaffOption] = useState([]);
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const { data, isSuccess, isFetching } =
  useGetpatientsQuery(
    {
      search: "",
      limit: pageSize,
      page: page,
    },
    { refetchOnMountOrArgChange: true }
  );

  const { data: getStaffs } = useGetStaffsQuery(
    {
      search: "",
      limit: pageSize,
      page: page,
    },
    { refetchOnMountOrArgChange: true }
  );

  const [addappointment, { isLoading: addLoading }] =
    useAddappointmentMutation();
  const [updateappointment, { isLoading }] = useUpdateappointmentMutation();

  useEffect(() => {
    if (data) {
      const response = data?.data?.map((x) => {
        return { label: x.name, value: x.id };
      });
      setOption(response);
    }
  }, [data]);

  useEffect(() => {
    if (getStaffs) {
      const response = getStaffs?.data?.map((x) => {
        return { label: x.name, value: x.id };
      });
      setStaffOption(response);
    }
  }, [getStaffs]);

  const options = [
    { label: "Doctor", value: "1" },
    { label: "Helper", value: "2" },
    { label: "Nurse", value: "3" },
  ];

  const onSubmit = async (data) => {
    const payload = { ...data, id: modalData?.id };
    try {
      let response;
      if (modalData) {
        response = await updateappointment(payload);
      } else {
        response = await addappointment(data);
      }

      if (response.data.code === 200) {
        setIsOpen(false);
        refetch();
        success(
          response?.data?.message || modalData
            ? "Client Updated SUccessfully"
            : "Client Added Successfully"
        );
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  useEffect(() => {
    if (modalData) {
      setValue("patient_id", modalData.patient_id);
      setValue("mobile_no", modalData.patient?.mobile_no);
      setValue("email", modalData.patient?.email);
      setValue("appointment_date_at", formatDate(modalData.appointment_date_at));
      setValue("appointment_time_at", modalData.appointment_time_at);
      setValue("staff_id", modalData.staff_id);
    } else {
      reset();
    }
  }, []);
  return (
    <div className="edit-profile-content">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-edit-profile mt-2"
      >
        <ThemeSelect
          name="patient_id"
          control={control}
          options={option}
          rules={{ required: "Patient is required" }}
          errors={errors}
          placeholder={"Patient"}
        />

        <Row className={"mt-3"}>
          <Col md={6}>
            <ThemeInput
              name="mobile_no"
              errors={errors}
              control={control}
              type={"number"}
              className={""}
              placeholder={"Phone"}
              rules={{
                required: {
                  value: true,
                  message: validationText.phoneNumber,
                },
                maxLength: {
                  value: validation.phoneNumberMax,
                  message: validationText.phoneNumberMax,
                },
              }}
            />
          </Col>
          <Col md={6}>
            <ThemeInput
              name="email"
              errors={errors}
              control={control}
              type={"email"}
              placeholder={"Email"}
              rules={{
                required: {
                  value: true,
                  message: validationText.emailRequired,
                },
                maxLength: {
                  value: validation.emailMax,
                  message: validationText.emailMax,
                },
              }}
            />
          </Col>
        </Row>

        <SimpleBasic
          text={"Appointment Details"}
          className={"mt-4 mb-0 fw-semibold"}
        />

        <Row className={""}>
          <Col md={6}>
            <ThemeSelect
              name="staff_id"
              control={control}
              label="Select Doctor"
              options={staffOption}
              rules={{ required: "Staff is required" }}
              errors={errors}
              className={"mt-3"}
              placeholder={"Doctor"}
            />
          </Col>
          <Col md={6}>
          <ThemeInput
          name="appointment_date_at"
          errors={errors}
          control={control}
          type={"date"}
          className={"mt-3"}
          placeholder={"Phone"}
          rules={{ required: "Appointment date is required" }}
        />
          </Col>
        </Row>

        <Row className={"mt-3"}>
          <Col md={6}>
          <ThemeInput
          name="appointment_time_at"
          errors={errors}
          control={control}
          type={"time"}
          className={"mt-3"}
          placeholder={"Phone"}
          rules={{ required: "Appointment time is required" }}
        />
          </Col>
          <Col md={6}>
          <ThemeInput
          name="hospital"
          errors={errors}
          control={control}
          type={"text"}
          className={"mt-3"}
          placeholder={"Hospital"}
          rules={{ required: "Hospital is required" }}
        />
          </Col>
        </Row>

        <div className="d-flex gap-3 mt-4 w-100 justify-content-end">
          <div className="btn-submit w-25">
            <Button
              className="cancel-btn w-100 bg-grey"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="btn-submit w-25">
            <Button
              disabled={isLoading}
              type="submit"
              className="theme-btn w-100"
            >
              {isLoading || addLoading ? (
                <ThemeSpinner />
              ) : modalData ? (
                "Update Appointment"
              ) : (
                "Create Appointment"
              )}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CreateAppointment;
